export default [
  { name: 'id', label: 'ID', type: 'immutable' },
  { name: 'first_name', label: 'First Name' },
  { name: 'last_name', label: 'Last Name' },
  { name: 'email', label: 'Email' },
  {
    name: 'two_factor_hours',
    label: 'Authentication Timeframe for 2FA',
    type: 'dropdown',
    options: [
      { value: '6', text: '6 Hours' },
      { value: '12', text: '12 Hours' },
      { value: '24', text: '24 Hours (Default)' },
      { value: '48', text: '48 Hours' },
      { value: '72', text: '72 Hours' },
    ],
  },
  { name: 'is_admin', label: 'Admin', type: 'boolean' },
  { name: 'otp_required_for_login', label: '2FA', type: 'boolean' },
]



// WEBPACK FOOTER //
// ./src/fields/users.js